// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-icon-button {
  color: black; /* Set color to Bootstrap primary color */
  transition: color 0.2s;
}

.add-icon-button:hover {
  font-size: 12px; /* Darker shade on hover */
}
`, "",{"version":3,"sources":["webpack://./src/Pages/BuzzCom/components/FriendComponents/AddIcon.css"],"names":[],"mappings":"AAAA;EACE,YAAY,EAAE,yCAAyC;EACvD,sBAAsB;AACxB;;AAEA;EACE,eAAe,EAAE,0BAA0B;AAC7C","sourcesContent":[".add-icon-button {\n  color: black; /* Set color to Bootstrap primary color */\n  transition: color 0.2s;\n}\n\n.add-icon-button:hover {\n  font-size: 12px; /* Darker shade on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
